import { render, staticRenderFns } from "./SamlLoginPage.vue?vue&type=template&id=70b657bd"
import script from "./SamlLoginPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SamlLoginPage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports